import { Call } from "./call-model";
import { InsuranceBeneficiary } from "./insurance-beneficiary";


export class Claim{
    claimId: number;
    policyId:number;
    current_process:number;
    // emission_date?:Date;
    // expiration_date?:string;
    // country_name?:string;
    // product_name?:string;
    // product_plan?:string;
    groupBenefitLevelLabel?:string;
    coverage_type?:string;
    insurance_sale?: string;
    sinister_date?: string;
    claim_date?:string;
    claim_status?:string;
    claim_initial_date ?: string;
    claim_end_date ?: string;
    // product_id?: number;
    // customer?:InsuranceCustomer[];
    beneficiary?:InsuranceBeneficiary[];
    coverageId?:string;
    amount_claim?: number;
    amount_authorized?: number;
    amount_pending?: number;
    amount_deducted?:number;
    amount_paid?:number;
    medic?: boolean;
    notes?:string;
    diligence_id?:number;
    user_id?:number;
    diagnostic_id?:number;
    communication_id?:number;
    campus_id?:number;
    notification_id?:Call;
    notes_id?:number;
    seat_id?:number;
    
}